import React from 'react';
import {
  HotelTeaserFragmentFragment,
  TermCategory,
} from '../../../generated/types';
import { TeaserProps } from '../../../types/global-types';
import ActivityCategoryBadge from '../../Common/ActivityCategoryBadge';
import Card, { CardProps } from '../../Common/Card';
import Location from '../../Common/Location';
import { CustomStarFilled } from '../../../config/icons';
import { Box, HStack } from '@chakra-ui/react';

type HotelTeaserProps = TeaserProps &
  Partial<CardProps> & {
    data: HotelTeaserFragmentFragment;
  };

export default function HotelTeaser({
  data,
  showCategory,
  ...rest
}: HotelTeaserProps) {
  return (
    <Card
      key={data.id}
      href={data.url}
      // href="/[[...path]]"
      image={data.teaserImage?.teaser?.url}
      title={data.title}
      text={data.detailsForFrontend ? data.detailsForFrontend.body! : ''}
      preTitle={
        showCategory ? (
          <ActivityCategoryBadge category={data.category as TermCategory} />
        ) : null
      }
      preBody={
        <Box>
          {data.averageRating?.ratingCount > 0 && (
            <HStack fontSize={rest.small ? 'xs' : 'sm'}>
              <CustomStarFilled fill="yellow.500" />
              <Box ml="2">
                {data.averageRating?.total.toFixed(2)} (
                {data.averageRating?.ratingCount} Bewertung
                {data.averageRating?.ratingCount > 1 ? 'en' : ''})
              </Box>
            </HStack>
          )}
        </Box>
      }
      meta={
        <Location
          country={data.country?.name || ''}
          region={data.region?.name || ''}
        />
      }
      {...rest}
    />
  );
}
